import muster from '@dbk-legacy/muster';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { getValues, ref, call } from '@dbk-legacy/muster/utils';
import { encode } from 'base-64';
import Guid from '../utils/guid';
import moment from 'moment';
import { INVESTMENT_API_CODES } from '../constants';
import isValidJsonString from '../utils/is-valid-json-string'; 
import convertDate from '../../src/utils/convertDate'

function parseDateFormat(content,messages){
  const clonedObject = JSON.parse(JSON.stringify(content)) 
  const recordsArray = clonedObject.data.records.slice();
  const currentLocalDate = moment(new Date())

  let newArrayAfterDate = []
  newArrayAfterDate = recordsArray.map((item) => {
    return convertDate(currentLocalDate, item,messages);
  })
  
  clonedObject.data.records = newArrayAfterDate;
  return clonedObject
}


export default () => {
  return muster()
    .path('getInvestmentData', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        // optimize the code later
        const base64Assets = encode(JSON.stringify(req.args[0]));
        const base64Actions = encode(JSON.stringify(req.args[1]));
        const [oResult] = await getValues(get(`roster.data.getFilterInvestmentData.["${base64Assets}"]["${base64Actions}"]["${guidStr}"]`));
        
        isValidJsonString(oResult).then(async (saveInvestmentResponse) => {
          if (saveInvestmentResponse) {
            if (saveInvestmentResponse.status.toUpperCase() === INVESTMENT_API_CODES.SUCCESS ) {
              let convertedInvestmentData = saveInvestmentResponse;
              if(saveInvestmentResponse.data){
                convertedInvestmentData = parseDateFormat(saveInvestmentResponse,messages)
                }
                await set('ui.investmentData', convertedInvestmentData);
              }
             else {
              await set('ui.investmentAPIError', saveInvestmentResponse.errorMsg);
            }
          } else {
            await set('ui.investmentAPIError', messages['app.investment.error.tryagain']);
          }
        }).catch(async () => {
          await set('ui.investmentAPIError', messages['app.investment.error.tryagain']);
        });
      },
    })

    // filter page
    .path('investmentFilter.getAssetClass', {
      call: async ({ req }, { get, set, call }) => {
        await set('investmentFilter.assetContent', null);
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        const [oReturn] = await getValues(get(`roster.data.investmentFilter.getAssetClass.["${guidStr}"]`));
        isValidJsonString(oReturn).then(async (saveAssetResponse) => {
          if (saveAssetResponse) {
            if (saveAssetResponse.status.toUpperCase() === INVESTMENT_API_CODES.SUCCESS ) {
                await set('investmentFilter.assetContent', saveAssetResponse);
              }
             else {
              await set('investmentFilter.investmentFilterError', saveAssetResponse.errorMsg);
            }
          } else {
            await set('investmentFilter.investmentFilterError', messages['app.investment.error.tryagain']);
          }
        }).catch(async () => {
          await set('investmentFilter.investmentFilterError', messages['app.investment.error.tryagain']);
        });
      },
    })


    .path('ui.investmentData', variable(""))
    .path('ui.investmentAPIError', variable(""))
    .path('investment.getSelectedAssetsActions', variable(""))
    .path('investment.fromDetailsPage', variable(false))
    // filter page
    .path('investmentFilter.assetContent', variable())
    .path('investmentFilter.isLoading', variable(false))
    .path('investmentFilter.investmentFilterError', variable(""))
}

